export { default } from './ABHAConsents';
